import { AdminAppState } from '../../state';
import { getPageTags } from './get-page-tags';
import { identity } from 'lodash';

export const getPageTagsArray = (pageKey: string) => (
  state: AdminAppState,
): string[] =>
  getPageTags(pageKey)(state)
    .split(/(\s+|,)/)
    .map(tag => tag.trim())
    .filter(v => v !== ',')
    .filter(identity);
